package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import com.schoolconnect.app.repository.systemlookup.SystemLookupOptions

@Serializable
data class QuickMarkRequest(
    @SerialName("class_id") val classId: String,
    @SerialName("attendance_date") val attendanceDate: String,
    @SerialName("default_status") val defaultStatus: String = SystemLookupOptions.codes("ATTENDANCE_STATUS").firstOrNull().orEmpty(),
    val exceptions: List<QuickMarkExceptionRequest> = emptyList()
)

@Serializable
data class QuickMarkExceptionRequest(
    @SerialName("student_id") val studentId: String,
    val status: String,
    val remarks: String? = null
)

@Serializable
data class AttendanceUpdateRequest(
    val status: String,
    val remarks: String? = null
)

@Serializable
data class AttendanceRecordRequest(
    @SerialName("student_id") val studentId: String,
    @SerialName("class_section_id") val classSectionId: String,
    @SerialName("recorded_by_staff_id") val recordedByStaffId: String? = null,
    val status: String,
    val remarks: String? = null
)
